import React from 'react';
import intl from 'react-intl-universal';
import { LANGUAGES } from './constants/constants';
import { connect } from 'react-redux';

const locales = {
  [LANGUAGES.FALLBACK]: require('./locales/en-US.json'),
  [LANGUAGES.EN_US]: require('./locales/en-US.json'),
  [LANGUAGES.FR_CA]: require('./locales/fr-CA.json'),
  [LANGUAGES.PT_BR]: require('./locales/pt-BR.json'),
};

class I18N extends React.Component {
  state = {
    initDone: false,
  };

  componentDidMount() {
    this.setLanguage(this.props.selectedLocale.code);
  }

  //
  // modify this to make an axios call to a language set in the future
  // grab on demand locales
  //

  setLanguage = language => {
    intl
      .init({
        currentLocale: language,
        fallbackLocale: LANGUAGES.FALLBACK,
        locales,
      })
      .then(() => {
        this.setState({ initDone: true });
      });
  };

  render() {
    return this.state.initDone && this.props.children;
  }
}

const mapStateToProps = ({ language }) => ({
  selectedLocale: language.selectedLocale,
});

export default connect(mapStateToProps)(I18N);
